import Slider from 'react-slick';
import { SLIDER_PROPS } from '../types';
import { CarouselNextArrow } from '../utils/CarouselNextArrow';
import { CarouselPrevArrow } from '../utils/CarouselPrevArrow';

export const SimpleSlider = ({ children }: SLIDER_PROPS): JSX.Element => {
  const settings = {
    className: 'center',
    centerMode: true,
    centerPadding: '40px',
    dots: true,
    dotsClass: 'slick-dotss',
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    lazyload: 'progressive',
    nextArrow: <CarouselNextArrow classes="px-10" />,
    prevArrow: <CarouselPrevArrow classes="px-10" />,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: '150px',
          nextArrow: <CarouselNextArrow classes="px-20" />,
          prevArrow: <CarouselPrevArrow classes="px-20" />,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          centerPadding: '60px',
          nextArrow: <CarouselNextArrow classes="px-9" />,
          prevArrow: <CarouselPrevArrow classes="px-9" />,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerPadding: '60px',
          nextArrow: <CarouselNextArrow classes="px-9" />,
          prevArrow: <CarouselPrevArrow classes="px-9" />,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          nextArrow: <div></div>,
          prevArrow: <div></div>,
        },
      },
    ],
  };

  return <Slider {...settings}>{children}</Slider>;
};
